<template>
  <div>
    <Header />
    <div class="intro">
      <Nav />
      <div class="container">
        <div class="content">
          <div class="name">溯源优才<sup class="cr">®</sup>计划</div>
          <div class="r1">
            为推动人力资源信息防伪溯源的发展和提高社会人力资源利用水平，
            <!-- 国家市场监督管理总局所属的<br />“全国产品防伪溯源验证公共平台”提出了【溯源优才计划】 -->
            中国防伪行业协会“全国产品防伪溯源验证公共平台”提出了【溯源优才计划】，从教育过程到就业职场经历以及<br />社会生活深度溯源，重新定义人力资源信息追溯体系。
          </div>
        </div>

        <div class="serviceList flex_between">
          <div class="serviceItem" @click="handleRedirect('personalServices')">
            <i class="icon icon_ps"></i>
            <div class="name">
              <div>个人服务</div>
              <span>Personal Services</span>
              <i class="icon_arrow_right"></i>
            </div>
          </div>
          <div class="serviceItem" @click="handleRedirect('educationalServices')">
            <i class="icon icon_eis"></i>
            <div class="name">
              <div>教育机构服务</div>
              <span>Educational Institution<br />Services</span>
              <i class="icon_arrow_right"></i>
            </div>
          </div>
          <div class="serviceItem" @click="handleRedirect('employerServices')">
            <i class="icon icon_es"></i>
            <div class="name">
              <div>用人单位服务</div>
              <span>Employer Services</span>
              <i class="icon_arrow_right"></i>
            </div>
          </div>
          <div class="serviceItem" @click="handleRedirect('socialGroupServices')">
            <i class="icon icon_sgs"></i>
            <div class="name">
              <div>社会团体服务</div>
              <span>Social Group Services</span>
              <i class="icon_arrow_right"></i>
            </div>
          </div>
          <div class="serviceItem" @click="handleRedirect('CooperationProjectSupportServices')">
            <i class="icon icon_cpss"></i>
            <div class="name">
              <div>合作项目支撑服务</div>
              <span>Cooperation Project <br />Support Services</span>
              <i class="icon_arrow_right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Nav from "@/components/Nav.vue";
export default {
  components: { Header, Nav, Footer },
  methods: {
    handleRedirect(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss" scoped>
.intro {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/bg.png") no-repeat;
  background-size: cover;
  //   padding: 108px 49px 83px 47px;
  font-size: 16px;
  font-family: PingFang SC;
  color: #fefefe;
  // line-height: 30px;
  text-align: center;
  padding-bottom: 132px;
  .content {
    padding: 80px;
    line-height: 30px;
    .name {
      font-size: 49.5px;
      font-family: Source Han Serif CN;
      font-weight: bold;
      color: #ffffff;
      margin-bottom: 40px;
      .cr {
        font-size: 22px;
        vertical-align: text-top;
      }
    }
    .r1 {
      margin-bottom: 53px;
      margin: 0 auto;
      width: 717px;
    }
  }
}
.serviceList {
  background: #1a3671;
  display: flex;
  justify-content: center;
  margin-left: 47px;
  margin-right: 47px;
  border-radius: 2px;
}
.serviceItem {
  text-align: center;
  width: 219px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  height: 191px;
  justify-content: flex-start;
  padding-top: 42px;
  .name {
    display: flex;
    flex-direction: column;
    align-items: center;
    > div {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      margin-bottom: 8px;
    }
    > span {
      color: #edf0f6;

      font-size: 15px;
      font-family: PingFang SC;
    }
  }
}
.icon {
  display: inline-block;
  width: 50px;
  height: 50px;
  background-size: 100% !important;
  margin-bottom: 10px;
}
.icon_ps {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_ps_on.png") no-repeat;
}
.icon_eis {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_eis_on.png") no-repeat;
}
.icon_es {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_es_on.png") no-repeat;
}
.icon_sgs {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_sgs_on.png") no-repeat;
}
.icon_cpss {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_cpss_on.png") no-repeat;
}
.serviceItem:hover {
  background: #436dc6;
  transform: scale(1, 1);
  -ms-transform: scale(1, 1);
  -webkit-transform: scale(1.2, 1.2);
  z-index: 2;
  border-radius: 4px;

  .icon_ps {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_ps_on.png") no-repeat;
    // transform: scale(0.83335);
  }
  .icon_eis {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_eis_on.png") no-repeat;
  }
  .icon_es {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_es_on.png") no-repeat;
  }
  .icon_sgs {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_sgs_on.png") no-repeat;
  }
  .icon_cpss {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_cpss_on.png") no-repeat;
  }
  &::before {
    display: none;
  }
  div {
    color: #fff;
  }
  span {
    color: #fff;
  }
  .icon_arrow_right {
    display: block;
  }
}
.serviceItem > img {
  width: 50px;
  height: 50px;
  margin-bottom: 11px;
}
// .serviceItem > div {
//   font-size: 15px;
//   font-family: PingFang SC;
//   font-weight: 500;
//   color: #3a61b1;
//   margin-bottom: 8px;
// }
// .serviceItem > span {
//   color: #b9b9b9;
//   font-size: 14px;
//   font-family: PingFang SC;
// }
.serviceItem:not(:first-child)::before {
  content: "";
  border-left: 1px solid #dadada;
  height: 58px;
  position: absolute;
  left: 0px;
  top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue